import { InfoWidgetType, SmartLinkWidgetType } from 'fym-common/src/db/enums';

export enum CreationTemplateId {
  empty = 'empty',
  linkHub = 'linkHub',
  tour = 'tour',
  merch = 'merch',
}

/** One block the template lays down. */
export interface CreationTemplateBlock {
  type: SmartLinkWidgetType;
  /** Only for `info`: the starter line the template writes into it. */
  heading?: string;
}

export interface CreationTemplateHeadings {
  tour: string;
  merch: string;
}

/**
 * What each starting point actually builds.
 *
 * Only blocks that exist are in here. The design drew dates, tickets, a
 * product and a countdown; the app has none of those, and a template that
 * promised them would create a page missing half its rows.
 *
 * Only `profile` and `socialLinks` can be created empty — a link block needs a
 * url, an image block needs an upload, and neither is something the artist has
 * given the sheet yet. So the richer templates differ from the plain one by an
 * `info` heading to write under, and Tour and Merch drop differ from each
 * other only by that line. That is the honest extent of it until there are
 * blocks for dates and products.
 */
export function templateBlocks(id: CreationTemplateId, headings: CreationTemplateHeadings): CreationTemplateBlock[] {
  switch (id) {
    case CreationTemplateId.linkHub:
      return [{ type: SmartLinkWidgetType.profile }, { type: SmartLinkWidgetType.socialLinks }];
    case CreationTemplateId.tour:
      return [
        { type: SmartLinkWidgetType.profile },
        { type: SmartLinkWidgetType.info, heading: headings.tour },
        { type: SmartLinkWidgetType.socialLinks },
      ];
    case CreationTemplateId.merch:
      return [
        { type: SmartLinkWidgetType.profile },
        { type: SmartLinkWidgetType.info, heading: headings.merch },
        { type: SmartLinkWidgetType.socialLinks },
      ];
    case CreationTemplateId.empty:
    default:
      return [{ type: SmartLinkWidgetType.profile }];
  }
}

/** The raw data one template block is created with. */
export function templateBlockData(block: CreationTemplateBlock) {
  if (block.type === SmartLinkWidgetType.info) {
    return { text: block.heading ?? '', type: InfoWidgetType.title };
  }
  return {};
}

export const creationTemplateIds: CreationTemplateId[] = [
  CreationTemplateId.empty,
  CreationTemplateId.linkHub,
  CreationTemplateId.tour,
  CreationTemplateId.merch,
];
